import { _LIST_PAGINATION_MODEL } from '../app/models';

/**
 *  포인트 내역 리스트 검색 옵션 모델
 */
export const POINT_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  유저 ID
   */
  userId: null,
  /**
   *  내역 종류
   */
  type: null,
  /**
   *  적립/사용처
   */
  cause: null,
  /**
   *  발급한 관리자 리스트
   */
  adminIdList: [],
};

/**
 *  포인트 내역 리스트 검색 옵션 모델
 */
export const POINT_LIST_SORT_OPTION_MODEL = {
  /**
   *  유저 ID
   */
  userId: null,
  /**
   *  액수
   */
  amount: null,
  /**
   *  생성시간
   */
  createDate: 'descend',
};

/**
 *  포인트 발급 내역 리스트 검색 박스 모델
 */
export const POINT_ISSUE_HISTORY_LIST_SEARCH_DATA_MODEL = {
  /**
   *  발급 내역 id
   */
  pointIssueHistoryId: null,
  /**
   *  발급한 관리자 리스트
   */
  adminIdList: [],
  /**
   *  메모
   */
  memo: null,
  /**
   *  포인트 발급 데이터 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  포인트 발급 내역 리스트 검색 박스 모델
 */
export const POINT_ISSUE_HISTORY_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  발급 내역 id
   */
  pointIssueHistoryId: null,
  /**
   *  발급한 관리자 리스트
   */
  adminIdList: [],
  /**
   *  메모
   */
  memo: null,
  /**
   *  포인트 발급 데이터 생성일
   */
  createDate: null,
};

/**
 *  포인트 발급 내역 리스트 검색 박스 모델
 */
export const POINT_ISSUE_HISTORY_DETAIL_FILTER_OPTION_MODEL = {
  /**
   * 내역 종류
   */
  type: null,
  /**
   *  적립/사용처
   */
  pointCauseId: null,
};

/**
 *  포인트 발급받을 유저 리스트 서치 옵션 모델
 */
export const POINT_GENERATE_USER_SEARCH_OPTION_MODEL = {
  /**
   *  회원번호 or 전화번호
   */
  searchType: {
    type: 0,
    value: null,
  },
  /**
   *  쿠폰 발급받을 유저 이름
   */
  name: null,
  /**
   *  쿠폰 발급받을 유저 아이디
   */
  account: null,
  /**
   *  쿠폰 발급받을 유저의 상태
   */
  status: null,
  /**
   *  쿠폰 발급받을 유저의 가입날짜
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  포인트 발급받을 유저 리스트 정렬 옵션 모델
 */
export const POINT_GENERATE_USER_SORT_OPTION_MODEL = {
  /**
   *  회원번호
   */
  userId: 'descend',
  /**
   *  사용 가능한 포인트
   */
  pointAmount: 'descend',
  /**
   *  사용한 포인트
   */
  usedPointAmount: 'descend',
  /**
   *  가입일자
   */
  createDate: 'descend',
};

/**
 *  포인트 랭킹 검색 박스 모델
 */
export const POINT_RANKING_LIST_SEARCH_DATA_MODEL = {
  /**
   *  회원 번호
   */
  userId: null,
  /**
   *  회원 이름
   */
  userName: null,
  /**
   *  친구 추천 코드
   */
  referralCode: null,
  /**
   *  포인트 발급 받은 날짜
   */
  issuedDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  포인트 랭킹 검색 옵션 모델
 */
export const POINT_RANKING_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  회원 번호
   */
  userId: null,
  /**
   *  회원 이름
   */
  userName: null,
  /**
   *  친구 추천 코드
   */
  referralCode: null,
  /**
   *  포인트 발급 받은 날짜
   */
  issuedDate: null,
};

/**
 *  포인트 랭킹 정렬 옵션 모델
 */
export const POINT_RANKING_LIST_SORT_OPTION_MODEL = {
  /**
   *  남아있는 포인트
   */
  credit: 'descend',
};

/**
 *  포인트 레퍼럴 발급 리스트 검색 박스 모델
 */
export const POINT_REFERRAL_ISSUE_LIST_SEARCH_DATA_MODEL = {
  /**
   *  회원 번호
   */
  referralUserId: null,
  /**
   *  친구 추천 코드
   */
  referralCode: null,
  /**
   *  레퍼럴 발급 받은 날짜
   */
  referralIssueDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  포인트 사유 리스트 검색 옵션 모델
 */
export const POINT_CAUSE_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  내역 종류
   */
  type: null,
  /**
   *  적립/사용처
   */
  causeName: null,
};

/**
 *  포인트 레퍼럴 발급 리스트 검색 옵션 모델
 */
export const POINT_REFERRAL_ISSUE_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  회원 번호
   */
  referralUserId: null,
  /**
   *  친구 추천 코드
   */
  referralCode: null,
  /**
   *  레퍼럴 발급 받은 날짜
   */
  referralIssueDate: null,
};

/**
 *  포인트 레퍼럴 발급 리스트 정렬 옵션 모델
 */
export const POINT_REFERRAL_ISSUE_LIST_SORT_OPTION_MODEL = {
  /**
   *  레퍼럴 횟수
   */
  referralCount: 'descend',
};

export const POINT_BULK_APPLY_MODEL = {
  /**
   *  내역 종류
   */
  type: null,
  /**
   *  적립/사용처
   */
  pointCauseId: null,
  /**
   *  액수
   */
  amount: null,
};

export const POINT_ISSUED_USER_MODEL = {
  /**
   *  포인트 발급받을 유저
   */
  userList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: POINT_GENERATE_USER_SEARCH_OPTION_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: POINT_GENERATE_USER_SEARCH_OPTION_MODEL,
    /**
     *  정렬 옵션
     */
    sortOption: POINT_GENERATE_USER_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },
  /**
   *  포인트 발급 페이지에서 일괄 설정에서 사용되는 MODEL
   */
  pointBulkApply: POINT_BULK_APPLY_MODEL,
  /**
   *  선택된 쿠폰 발급받을 유저 리스트
   */
  selectedUserIdList: [],
  /**
   *  선택된 쿠폰 발급받을 유저 정보 리스트, 포인트 type, cause, amount
   */
  selectedUserInfoList: [],
};
